import React from "react";
import { CONTRACT_STYLES, REVIEW_STYLES, RISK_STYLES } from "@/lib/vendors";

const pill = "inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap";

export const RiskBadge = ({ level, prefix, testId }) => (
  <span data-testid={testId} className={`${pill} ${RISK_STYLES[level] || ""}`}>{prefix ? `${prefix} ` : ""}{level}</span>
);

export const ContractBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`${pill} ${CONTRACT_STYLES[status] || ""}`}>{label || status}</span>
);

export const ReviewBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`${pill} ${REVIEW_STYLES[status] || ""}`}>{label || status}</span>
);

export const ScoreDial = ({ value, label, sub, tone, testId }) => (
  <div className="flex-1 min-w-[150px]" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">{label}</div>
    <div className={`text-3xl font-bold font-mono tracking-tight mt-1 ${tone}`} data-testid={`${testId}-value`}>
      {value == null ? "—" : value}
    </div>
    <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>
  </div>
);
